import { render, staticRenderFns } from "./NoteConfig.vue?vue&type=template&id=f14edb0e&"
import script from "./NoteConfig.vue?vue&type=script&lang=js&"
export * from "./NoteConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports